(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["appstle-loyalty-faq"] && !Shopify.designMode) return;
  try {
    (() => {
    const templateId = 'gc-loyalty-faq-template';
    const faqId = 'gc-loyalty-faq';
    const builtInFaqSelector = '#appstleLoyaltyPageV2FaqSection';
    const transactionSectionSelector = '#appstleLoyaltyPageV2TransactionHistorySection';
    const loyaltyPageSelector = '.appstleLoyaltyPageV2';

    const mountFaq = () => {
      if (document.getElementById(faqId)) return;

      const template = document.getElementById(templateId);
      if (!template) return;

      const builtInFaq = document.querySelector(builtInFaqSelector);
      const transactionSection = document.querySelector(transactionSectionSelector);
      const loyaltyPage = document.querySelector(loyaltyPageSelector);
      if (!builtInFaq && !transactionSection && !loyaltyPage) return;

      const faq = template.content.firstElementChild.cloneNode(true);

      if (builtInFaq) {
        builtInFaq.insertAdjacentElement('beforebegin', faq);
        return;
      }

      if (transactionSection) {
        transactionSection.insertAdjacentElement('afterend', faq);
        return;
      }

      loyaltyPage.appendChild(faq);
    };

    let mountQueued = false;
    const queueMount = () => {
      if (mountQueued) return;
      mountQueued = true;
      window.requestAnimationFrame(() => {
        mountQueued = false;
        mountFaq();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', mountFaq, { once: true });
    } else {
      mountFaq();
    }

    const observer = new MutationObserver(queueMount);
    observer.observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["appstle-sms-button-fix"] && !Shopify.designMode) return;
  try {
    (() => {
    const restoreSmsButton = () => {
      const cards = document.querySelectorAll(
        '.appstleLoyaltyPageV2 .appstleLoyaltyPageV2WaysToEarnListItem'
      );

      cards.forEach((card) => {
        const title = card.querySelector(
          '.appstleLoyaltyPageV2WaysToEarnListItemTitle'
        );

        if (
          !title ||
          title.textContent.trim().toLowerCase() !== 'subscribe to sms'
        ) {
          return;
        }

        const description = card.querySelector(
          '.appstleLoyaltyPageV2WaysToEarnListItemDescription'
        );

        if (
          !description ||
          description.querySelector('.loyalty-sms-subscribe-button')
        ) {
          return;
        }

        Array.from(description.childNodes).forEach((node) => {
          if (
            node.nodeType === Node.TEXT_NODE &&
            node.textContent.trim().toLowerCase() === 'subscribe'
          ) {
            node.remove();
          }
        });

        const link = document.createElement('a');

        link.href = '/pages/sms-signup';
        link.className = 'loyalty-sms-subscribe-button';
        link.textContent = 'Subscribe';

        description.appendChild(link);
      });
    };

    const start = () => {
      restoreSmsButton();

      const observer = new MutationObserver(restoreSmsButton);

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, {
        once: true
      });
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
